import {
    LINKEDCALENDARV2_ENTRY_TYPENAME,
    LINKEDCALENDAR_ENTRY_TYPENAME,
    LOCALCACHEFORREMOTECALENDAR_ENTRY_TYPENAME,
} from './constants';

/**
 * Returns the type of shared calendar
 * @param calendarEntry, the calendar entry

 */
export const getSharedCalendarType = (calendarEntry?: {
    __typename?: string;
    IsGroupMailboxCalendar?: boolean | null;
}): string => {
    if (calendarEntry && !calendarEntry.IsGroupMailboxCalendar) {
        switch (calendarEntry.__typename) {
            case LINKEDCALENDARV2_ENTRY_TYPENAME:
                return LINKEDCALENDARV2_ENTRY_TYPENAME;
            case LINKEDCALENDAR_ENTRY_TYPENAME:
                return LINKEDCALENDAR_ENTRY_TYPENAME;
            case LOCALCACHEFORREMOTECALENDAR_ENTRY_TYPENAME:
                return LOCALCACHEFORREMOTECALENDAR_ENTRY_TYPENAME;
            default:
                break;
        }
    }
    return 'NONE';
};
